<template>
  <v-app>
    <v-container fluid class="article-actions">
      <b-alert
        :variant="variant"
        v-model="showValidationAlert"
        dismissible
        style="
          position: fixed;
          width: 100%;
          z-index: 99999;
          top: 75px;
          right: 0;
        "
      >
        {{ alertMsg }}</b-alert
      >
      <v-row>
        <v-col cols="4">
          <v-subheader>عنوان</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="عنوان" v-model="title"
            :rules="[() => !!title || 'این فیلد الزامی است']"
            required
            :error-messages="errorMessages"
             ref="title"></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn class="ml-4 white--text font-weight-bold indigo darken-4 white--text" @click="editHandler">
          ثبت کردن
        </v-btn>
        <router-link to='/product-management/brand'>
          <v-btn class=" white--text font-weight-bold indigo lighten-2"> انصراف </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import baseURL from '@/axios'
export default {
  data() {
    return {
      title: "",

      errorMessages: "",

      formHasErrors: false,
      showValidationAlert: false,
      variant: "",
      alertMsg: "",
    };
  },
  watch: {
    title() {
      this.errorMessages = "";
    },
  },
  computed: {
    ...mapGetters(["tokenValue", "articleInfoValue", "itemList"]),
    form() {
      return {
        title: this.title,
      };
    },
  },
  methods: {
    async editHandler() {
      await axios
        .post(
          `${baseURL}Brand/Add`,
          {
            name: this.title,
          },
          {
            headers: {
              Authorization: `Bearer ${this.tokenValue}`,
            },
          }
        ).then((res) => {
                this.showValidationAlert = true;
                this.variant = "success";
                this.alertMsg = res.data.message;
                setTimeout(() => {
                  this.$router.push("/product-management/brand");
                }, 3000);
              })
              .catch((e) => {
                this.showValidationAlert = true;
                this.variant = "danger";
                this.alertMsg = e.response.data.message;
              });
    },
  },
};
</script>

<style>
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}
</style>